<template>
  <b-container>
    <h1>Meet Our Team</h1>
    <div style="width: 75%" class="mb-5 mx-auto">
      <p class="p-up">
        Our team is devoted to helping you do great citizen science and
        community science projects. We are passionate about supporting and
        amplifying the impacts and outcomes of your work. We have been fortunate
        to have had a great team of people help us make CitSci possible, many of
        whom are volunteers (<i class="fas fa-star"></i>) just like you!
      </p>

      <div style="text-align: center">
        <p class="p-up" style="color: #849a39">
          <i>to all - past and present - we are grateful</i>
        </p>
      </div>
    </div>

    <h2 class="text-center">Current Staff</h2>
    <div class="row align-items-stretch justify-content-center">
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/StacyLynn.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Stacy Lynn</h4>
              <p class="card-text flex-none">
                Stacy is our
                <strong>director of research and education</strong>. She
                integrates socio-ecological data and learning outcomes.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/Sarah_Newman.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Sarah Newman</h4>
              <p class="card-text flex-none">
                Sarah is our
                <strong>director of operations</strong>. She engages people in
                science at local and global scales.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/Gregory_Newman.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Greg Newman</h4>
              <p class="card-text flex-none">
                Greg is <strong>co-founder and director</strong> at CitSci. He
                helps engage communities, co-develop CitSci, and co-create
                successful projects.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/Guhan_Sivakami.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Guhan Sivakami</h4>
              <p class="card-text flex-none">
                Guhan is our <strong>database manager</strong>. He manages the
                CitSci database and helps with full stack development.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/BrandonBudnicki.jpg"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">
                Brandon Budnicki
              </h4>
              <p class="card-text flex-none">
                Brandon is our lead <strong>lead developer</strong>. He turns
                our community vision for a platform into reality.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/Lee.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Lee Casuto</h4>
              <p class="card-text flex-none">
                Lee built our first mobile app for iOS and continues to serve as
                a <strong>consultant</strong> with Leeway Software Designs. (<i
                  class="fas fa-star"
                ></i>
                volunteer)
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/CarolineNickerson.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">
                Caroline Nickerson
              </h4>
              <p class="card-text flex-none">
                Caroline is our <strong>communications lead</strong>. She
                manages social media, email outreach, and more.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/AsmitaBasu2.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Asmita Basu</h4>
              <p class="card-text flex-none">
                Asmita Basu is a <b>student assistant</b> working on communications and platform support.
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <h2 class="text-center">Graduate Students</h2>

    <div class="row align-items-stretch justify-content-center">
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/BrandonBudnicki.jpg"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">
                Brandon Budnicki
              </h4>
              <p class="card-text flex-none">
                Brandon is <strong>also</strong> studying how to improve the
                quality of participatory science projects and new features like
                location privacy.
              </p>
            </div>
          </div>
        </div>
      </div>
            <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/AsmitaBasu2.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">
                Asmita Basu
              </h4>
              <p class="card-text flex-none">
                Asmita is <strong>also</strong> a PhD student studying how how public participation can contribute to ecological research and conservation.
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <h2 class="text-center">Past Team Members</h2>

    <div class="row align-items-stretch justify-content-center">
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/Russell_Scarpino.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">
                Russell Scarpino
              </h4>
              <p class="card-text flex-none">
                Russell was previously lead developer at CitSci. He helped build
                and launch CitSci 2.0 and is a contractor for NOAA
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/AlyciaCrall.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Alycia Crall</h4>
              <p class="card-text flex-none">
                Alycia is a co-founder and visionary for CitSci. She led initial
                proposal development and is now working at Battel on NEON.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/DanielleBackman.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">
                Danielle Backman
              </h4>
              <p class="card-text flex-none">
                Danielle served as our communications lead and was instrumental
                in helping us work towards GDPR compliance.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/Manoj.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Manoj Sreekumar</h4>
              <p class="card-text flex-none">
                Manoj built our first Android app and worked with Lee on our
                apps. He is a software engineer at Markit.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/JimGraham.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Jim Graham</h4>
              <p class="card-text flex-none">
                Jim is a co-founder of CitSci and now is Assistant Professor at
                Humboldt State University where he teaches GIS.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/Pramod.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">
                Pramod Shashidhara
              </h4>
              <p class="card-text flex-none">
                Pramod was a software engineer at CitSci and now works as senior
                software engineer at Atlassian.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/EllenEisenbeis.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Ellen Eisenbeis</h4>
              <p class="card-text flex-none">
                Ellen worked at CitSci as a ESS SUPER student. She helped us
                better understand how project traits impact data usability.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/Hennick.jpg"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Hennick Yibra</h4>
              <p class="card-text flex-none">
                Hennick was an associate developer. He worked on full-stack
                development to accelerate our objectives.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/JC.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">J.C. Sanchez</h4>
              <p class="card-text flex-none">
                J.C. was one of our front-end developers. He
                interned with us and worked on standardizing the user interface of CitSci.
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/MadisonStoker.jpg"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Madison Stroker</h4>
              <p class="card-text flex-none">
                Madison is an undergraduate CitSci assistant who oversees help
                center operations and works closely with the development and
                communications teams.
              </p>
            </div>
          </div>
        </div>
      </div>

    </div>

    <h2 class="text-center">Past Graduate Students</h2>

    <div class="row align-items-stretch justify-content-center">
            <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/BrianFauver.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Brian Fauver</h4>
              <p class="card-text flex-none">
                Brian was a graduate student at CitSci. He now woks at the
                Colorado Department of Transportation.
                <b-link
                  href="https://blog.citsci.org/2020/10/12/how-citizen-science-paved-the-way-for-this-students-career/"
                  target="NewWindow"
                  >Learn more
                </b-link>
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/DaniLinHunter.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Dani Lin Hunter</h4>
              <p class="card-text flex-none">
                Dani studied how communities talk about citizen science. She is
                interested in agency and how design influences participation in
                projects. (<i class="fas fa-star"></i>
                volunteer)
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/RinaHauptfeld.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Rina Hauptfeld</h4>
              <p class="card-text flex-none">
                Rina is interested in community capacity development and how
                participatory natural resource management builds capacity in
                projects. (<i class="fas fa-star"></i>
                volunteer)
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/Rachit1.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Rachit Dalal</h4>
              <p class="card-text flex-none">
                Rachit is interested in the intersection of technology and
                society, particularly how digital tools can support
                community-driven research. (<i class="fas fa-star"></i>
                volunteer)
              </p>
            </div>
          </div>
        </div>
      </div>
      <div class="col-sm-6 col-xl-4 mb-3">
        <div class="card p-3 h-100">
          <div class="row align-items-stretch h-100">
            <div
              class="col-md-4 align-items-center d-flex justify-content-center"
            >
              <img
                src="/assets/images/staff/IsabellaHarris.png"
                class="img-fluid rounded-circle"
              />
            </div>
            <div class="col-md-8 d-flex flex-column justify-content-center">
              <h4 class="card-title flex-none pt-3 pt-md-0">Isabella Harris</h4>
              <p class="card-text flex-none">
                Bella is interested in how citizen science facilitates effective
                virtual environmental participant experiences. (<i
                  class="fas fa-star"
                ></i>
                volunteer)
              </p>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="mt-4">
      <p>
        Many other students at Colorado State University have helped make CitSci
        possible. These students have put enormous energy into making CitSci a
        success. To all - Danielle Backman, Nick Young, Michelle Lee, and many
        others - we are grateful. Finally, we express our heartfelt gratitude to
        Dr. Tom Stohlgren who mentored our co-founders Drs. Newman, Graham, and
        Crall and who provided a lab and research team flexible enough to
        entertain citizen science and embrace its contributions to invasive
        species ecology.
      </p>
    </div>
    <VueLoader v-if="isLoading" />
  </b-container>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
import VueLoader from "../layout/Loader.vue";

export default {
  created() {},

  computed: {
    ...mapGetters({
      isLoading: "staff/show/isLoading",
    }),
  },

  methods: {
    ...mapActions({
      preparePage: "staff/show/preparePage",
    }),
  },

  components: {
    VueLoader,
  },
};
</script>

<style lang="scss" scoped></style>
